import { CDN_URL } from "@/config/cdn";
import { Media } from "@/types/models/Media";
import { buildMediaCdnUrl, buildMediaVariantCdnUrl } from "@gogive/services";

export type VisualSize = "small" | "medium" | "large" | "preview" | "original";

export const getMediaCdnUrl = (
  accountId: string,
  mediaType: "logo" | "banner",
  mediaUrl?: string,
  size: VisualSize = "medium"
) => {
  if (!mediaUrl) return null;
  if (mediaUrl.includes("https")) return buildMediaCdnUrl(mediaUrl, CDN_URL);
  const key = mediaUrl.includes("/")
    ? mediaUrl
    : `account/${accountId}/${mediaType}/${size}/${mediaUrl}`;
  return buildMediaCdnUrl(key, CDN_URL);
};

export const getMediaUrl = (
  media?: Media,
  size: VisualSize = "small"
): string | undefined => {
  if (!media) return undefined;
  
  // For large/medium sizes, try full key first, then fallback to s3Key
  if (size === "large" || size === "medium") {
    const url = buildMediaVariantCdnUrl(media, "full", CDN_URL);
    // If buildMediaVariantCdnUrl returns null, try with the s3Key directly
    if (!url && media.s3Key) {
      return buildMediaCdnUrl(media.s3Key, CDN_URL) ?? undefined;
    }
    return url ?? undefined;
  }
  
  if (size === "small") {
    return buildMediaVariantCdnUrl(media, "thumb", CDN_URL) ?? undefined;
  }
  
  if (size === "preview") {
    return buildMediaVariantCdnUrl(media, "preview", CDN_URL) ?? undefined;
  }
  
  return buildMediaCdnUrl(media.s3Key, CDN_URL) ?? undefined;
};
